module.exports = __webpack_public_path__ + "img/ciazlogo.870b963d.svg";